import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH } from "../../Utils/Global";
import { cloneObject } from "../../Utils/Utils";

import Status from '../Helper/Status';
import Combobox from '../Helper/Combobox';
import AbstractEntity from './AbstractEntity';
import NumberFormat from 'react-number-format';
/**
* Class Capteur
* Capteur view component
**/
class CapteurParametre extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "CapteurParametre";
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="capteurParametreForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire du paramètre.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idCapteurParametre" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idCapteurParametre")} disabled="true" /></Col>
          </FormGroup>

          <FormGroup controlId="nom">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Nom</ControlLabel></Col>
            <Col sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("nom")} disabled={this.getReadOnly()} /></Col>
          </FormGroup>


          <FormGroup controlId="seuil">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Seuil d’alerte</ControlLabel></Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("seuil")} onValueChange={this.handleSeuilChange.bind(this)}
                decimalScale={2} thousandSeparator={" "} suffix={''} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>

          <FormGroup controlId="seuil_inferieur">
            <Col smOffset={2} sm={2}><Checkbox name="seuil_inferieur" onChange={this.handleCheckboxChange.bind(this)}
              checked={this.getObjectProperty("seuil_inferieur")} disabled={this.getReadOnly()}>Seuil inferieur</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="seuil_heure">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Temps de latence</ControlLabel></Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("seuil_heure")} onValueChange={this.handleValeurChange.bind(this)}
                decimalScale={0} thousandSeparator={" "} suffix={'H'} disabled={this.getReadOnly()} />
            </Col>
          </FormGroup>


          <FormGroup controlId="lastvalue">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Dernière valeur</ControlLabel></Col>
            <Col sm={2}>
              <NumberFormat className="form-control" value={this.getObjectProperty("lastvalue")}
                decimalScale={4} thousandSeparator={" "} suffix={''} disabled={true}  />
            </Col>
          </FormGroup>


          {/* Submit button */}
          {this.state.mode !== "readonly" ?
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" type="submit">Sauvegarder</Button>
              </Col>
            </FormGroup>: null
          }
        </Form>
      </div>
		);
	}


  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idCapteurParametre";
  }

  /**
  * sendFormData
  * Saves the data
  **/
  sendFormData () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    let capteurObj = cloneObject(this.state.object);
    let state = this.state;

    // Validation des champs mails
    if(this.getMailValidationState("email1", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    if(this.getMailValidationState("email2", true) === "error") {
      state.status = {
        type: 'danger',
        message: 'Le champ Mail complémentaire n\'est pas valide.'
      };
      this.setState(state);
      return;
    }

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(capteurObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        const newObj = JSON.parse(response.entity);

        this.setState({
          status: {
            type: 'success',
            message: 'Paramètre sauvegardé.'
          },
          object: newObj
        });

        if(this.props.onEdit) {
          this.props.onEdit.call(this, newObj);
        }
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Paramètre créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/capteurParametres/" + newObj.idCapteurParametre + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }
  handleValeurChange(values) {
    let objState = this.state;
    objState.object["seuil_heure"] = values.value;
    this.setState(objState);
  }

  handleSeuilChange(values) {
    let objState = this.state;
    objState.object["seuil"] = values.value;
    this.setState(objState);
  }


}
export default CapteurParametre;



// WEBPACK FOOTER //
// ./src/views/Entity/CapteurParametre.js